/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 5.99976C15.3137 5.99976 18 8.68605 18 11.9998M14 11.9998C14 13.1043 13.1046 13.9998 12 13.9998C10.8954 13.9998 10 13.1043 10 11.9998C10 10.8952 10.8954 9.99976 12 9.99976C13.1046 9.99976 14 10.8952 14 11.9998Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 21.9998C17.5228 21.9998 22 17.5226 22 11.9998C22 6.47691 17.5228 1.99976 12 1.99976C6.47715 1.99975 2 6.47691 2 11.9998C2 17.5226 6.47715 21.9998 12 21.9998ZM12 13.9998C13.1046 13.9998 14 13.1043 14 11.9998C14 10.8952 13.1046 9.99976 12 9.99976C10.8954 9.99976 10 10.8952 10 11.9998C10 13.1043 10.8954 13.9998 12 13.9998Z"
				fill="currentColor"
			/>
			<path
				d="M12 5.99976C15.3137 5.99976 18 8.68605 18 11.9998M22 11.9998C22 17.5226 17.5228 21.9998 12 21.9998C6.47715 21.9998 2 17.5226 2 11.9998C2 6.47691 6.47715 1.99976 12 1.99976C17.5228 1.99976 22 6.47691 22 11.9998ZM14 11.9998C14 13.1043 13.1046 13.9998 12 13.9998C10.8954 13.9998 10 13.1043 10 11.9998C10 10.8952 10.8954 9.99976 12 9.99976C13.1046 9.99976 14 10.8952 14 11.9998Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 5.25C11.5858 5.25 11.25 5.58578 11.25 6C11.25 6.41421 11.5858 6.75 12 6.75C14.8995 6.75 17.25 9.1005 17.25 12C17.25 12.4142 17.5858 12.75 18 12.75C18.4142 12.75 18.75 12.4142 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25ZM10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12ZM12 9.25C10.4812 9.25 9.25 10.4812 9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17.5 3.64678C15.9221 2.60572 14.0318 1.99976 12 1.99976C6.47715 1.99976 2 6.47691 2 11.9998C2 17.5226 6.47715 21.9998 12 21.9998C17.5228 21.9998 22 17.5226 22 11.9998C22 10.3811 21.6154 8.85235 20.9327 7.49976M12 5.99976C15.3137 5.99976 18 8.68605 18 11.9998M14 11.9998C14 13.1043 13.1046 13.9998 12 13.9998C10.8954 13.9998 10 13.1043 10 11.9998C10 10.8952 10.8954 9.99976 12 9.99976C13.1046 9.99976 14 10.8952 14 11.9998Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 5.99976C15.3137 5.99976 18 8.68605 18 11.9998M22 11.9998C22 17.5226 17.5228 21.9998 12 21.9998C6.47715 21.9998 2 17.5226 2 11.9998C2 6.47691 6.47715 1.99976 12 1.99976C17.5228 1.99976 22 6.47691 22 11.9998ZM14 11.9998C14 13.1043 13.1046 13.9998 12 13.9998C10.8954 13.9998 10 13.1043 10 11.9998C10 10.8952 10.8954 9.99976 12 9.99976C13.1046 9.99976 14 10.8952 14 11.9998Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 6.00024C11.25 5.58603 11.5858 5.25024 12 5.25024C15.7279 5.25024 18.75 8.27232 18.75 12.0002C18.75 12.4145 18.4142 12.7502 18 12.7502C17.5858 12.7502 17.25 12.4145 17.25 12.0002C17.25 9.10075 14.8995 6.75024 12 6.75024C11.5858 6.75024 11.25 6.41446 11.25 6.00024ZM12 10.7502C11.3096 10.7502 10.75 11.3099 10.75 12.0002C10.75 12.6906 11.3096 13.2502 12 13.2502C12.6904 13.2502 13.25 12.6906 13.25 12.0002C13.25 11.3099 12.6904 10.7502 12 10.7502ZM9.25 12.0002C9.25 10.4815 10.4812 9.25024 12 9.25024C13.5188 9.25024 14.75 10.4815 14.75 12.0002C14.75 13.519 13.5188 14.7502 12 14.7502C10.4812 14.7502 9.25 13.519 9.25 12.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
